import React, { useState, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import {
  CCard,CModal,
  CCardBody,CModalHeader,
  CButton,CModalBody,
  CCardHeader,CDropdown,
  CCol,CLabel,
  CDataTable,CTextarea,
  CRow,CForm, CFormGroup,
  CPagination,CFormText,
} from 'compat/coreui'

import axios from 'axios';
import moment from 'moment';
import {postData} from '../../../helpers/api';
import {ToastContainer, toast} from 'react-toastify';


const Category = () => {
  const history = useNavigate()
  const [title, setTitle] = useState('');
  const [subTitle, setSubTitle] = useState('');
  const [orderData, setOrderData] = useState([]);
  const [orderStatus, setOrderStatus] = useState('Pending');
  const [orderId, setOrderId] = useState("");
  const [modal, setModal] = useState(false);

  const toggle = (id)=>{
    // e.preventDefault()
    setModal(!modal);
    setOrderId(id)
  }

  useEffect(async () => {
    getData()
  }, [])

  function getData() {
    axios.get(`${process.env.REACT_APP_APP_API_URL}/api/order`,{
      headers: {
        'Authorization': 'Bearer '+localStorage.getItem('token')}
    }).then(res => {
      setOrderData(res.data.orders);
    }).catch(e => console.log(e))
  }

  const getPriceSymbol = type => {
    switch(type) {
      case 'price':
        return 'g'
      case 'priceHalf':
        return '1/2'
      case 'priceForth':
        return '1/4'
      case 'priceEight':
        return '1/8'
      case 'priceOz':
        return 'oz'
    }
  }

  const statusHandler = (e) => {
    e.preventDefault();
    console.log('handler', orderStatus, orderData, orderId)
    const data = {
      "orderId": orderId,
      "status": orderStatus
    }
    postData(`${process.env.REACT_APP_APP_API_URL}/api/order/status`, data).then(res =>{
      if(res.data.status){
        setModal(false);
        toast.success('Order status changed successfully');
        getData();
      }
    }).catch(console.log)

  }

  return (
    <CRow>
      <CCol xl={12}>
        <CCard>
          <CCardHeader className="category_header">
            Orders
          </CCardHeader>
          <CCardBody>
            <div className="table-responsive">
              <table className="table table-striped table-hover">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Product</th>
                    <th>Price</th>
                    <th>Price Type</th>
                    <th>Quantity</th>
                    <th>Status<small>(Change Status)</small></th>
                    <th>Buyer</th>
                    <th>Buyer Email</th>
                    <th>Address</th>
                    <th>Created At</th>
                  </tr>
                </thead>
                  <tbody>
                    {orderData && orderData.map((cat, index) => {
                        return (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{cat.product.name}</td>
                            <td>{cat.price}</td>
                            <td className="menu-price"> <span>{getPriceSymbol(cat.priceType)}</span></td>
                            <td>{cat.quantity}</td>
                            <td><CButton className="status_button" onClick={(e) => toggle(cat._id)}>{cat.status}</CButton></td>
                            <td>{cat.buyer.username}</td>
                            <td>{cat.buyer.email}</td>
                            <td>{cat.buyer.address1}</td>
                            <td>{moment(cat.createdAt).format('YYYY-MM-DD HH:mm')}</td>
                          </tr>
                        )
                      })
                    }
                  </tbody>
                </table>
            </div>
          </CCardBody>
        </CCard>
      </CCol>
      <CModal show={modal} onClose={toggle} className="order_modal">
          <CModalHeader closeButton>Change Order Status</CModalHeader>
          <CModalBody>
            <form onSubmit={statusHandler}>
              <CFormGroup>
                <CLabel htmlFor="nf-subtitle">Choose Order Status</CLabel>
                <CDropdown>
                  <select className="custom-select my-1 mr-sm-2 product_status" onChange={(e) => setOrderStatus(e.target.value)}>
                    <option value={"Pending"}>Pending</option>;
                    <option value={"OnTheWay"}>On The Way</option>;
                    <option value={"Accepted"}>Accepted</option>;
                    <option value={"Processing"}>Processing</option>;
                    <option value={"Completed"}>Completed</option>;
                    <option value={"Cancelled"}>Cancelled</option>;
                  </select>
                </CDropdown>
              </CFormGroup>
              <CButton color="success" className="mt-4" type="submit">Change Status</CButton>{' '}
              <CButton
                color="secondary"
                size="lg"
                className="mt-4 pl-3 pr-3"
                onClick={toggle}>
                  Cancel
              </CButton>
            </form>
          </CModalBody>
      </CModal>
    </CRow>
  )
}

export default Category;
